import { useState, useEffect } from 'react';
import { fetchProfile } from '@/epics/userProfile/api/viewProfileApiService';
import { useUserRole } from './useUserRole';

export const useClientStatus = () => {
  const { isClient, isLoading: roleLoading } = useUserRole();
  const [clientStatus, setClientStatus] = useState<
    'active' | 'inactive' | null
  >(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (roleLoading) {
      return;
    }

    if (!isClient) {
      setIsLoading(false);
      return;
    }

    let mounted = true;
    fetchProfile()
      .then((result) => {
        if (!mounted) {
          return;
        }
        if (result.success && result.data) {
          const s = result.data.status as string;
          setClientStatus(s === 'active' ? 'active' : 'inactive');
        }
        setIsLoading(false);
      })
      .catch(() => {
        if (mounted) {
          setIsLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, [isClient, roleLoading]);

  return { clientStatus, isLoading };
};
